// extracted by mini-css-extract-plugin
export default {"editor":"richtextEditor_editor__J5CA5","toolbarStyle":"richtextEditor_toolbarStyle__pFW7h"};